import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseItemBodyWrapper;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import RichContentRenderer from '../RichContentRenderer';
import { withStyleOverrides } from '@instructure/quiz-common';
var BaseItemBodyWrapper = /*#__PURE__*/function (_Component) {
  function BaseItemBodyWrapper() {
    _classCallCheck(this, BaseItemBodyWrapper);
    return _callSuper(this, BaseItemBodyWrapper, arguments);
  }
  _inherits(BaseItemBodyWrapper, _Component);
  return _createClass(BaseItemBodyWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        itemBody = _this$props.itemBody,
        id = _this$props.id;
      return jsx("div", {
        id: id,
        css: this.props.styles.wrapper,
        "data-automation": "sdk-item-wrapper"
      }, itemBody && jsx(RichContentRenderer, {
        customStyles: this.props.styles.itemBody,
        content: itemBody
      }), jsx("div", {
        css: this.props.styles.itemBody
      }, children));
    }
  }]);
}(Component);
_BaseItemBodyWrapper = BaseItemBodyWrapper;
_defineProperty(BaseItemBodyWrapper, "displayName", 'ItemBodyWrapper');
_defineProperty(BaseItemBodyWrapper, "componentId", "Quizzes".concat(_BaseItemBodyWrapper.displayName));
_defineProperty(BaseItemBodyWrapper, "propTypes", {
  // children should be PropTypes.node, but the node type can't validate React Portals
  // see https://github.com/facebook/prop-types/issues/167
  children: PropTypes.any,
  itemBody: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.object
});
_defineProperty(BaseItemBodyWrapper, "defaultProps", {
  children: null,
  itemBody: null,
  ariaHidden: false,
  id: ''
});
export var ItemBodyWrapper = withStyleOverrides(generateStyle, generateComponentTheme)(BaseItemBodyWrapper);
export default ItemBodyWrapper;